export const environment = {
  production: false,
  name: 'Development',
  api_url: 'https://royal-ipay-api-a4hsa6bjdwc7cubb.southafricanorth-01.azurewebsites.net',
  app_domain: 'https://www.royalipay.tech',
};
